import { Controller } from "@hotwired/stimulus"

// Живой предпросмотр сумм табеля (информационно, PRD §6.2).
// Ставка берётся из карты ставок: rates[objectId][payableGid] → ставка на объекте,
// иначе rates._defaults[payableGid] → базовая ставка лица.
export default class extends Controller {
  static targets = ["object", "rows", "total"]
  static values = { rates: Object }

  connect() {
    this.recalc = this.recalc.bind(this)
    // Пересчёт при динамическом добавлении/удалении строк (cocoon-vanilla-js).
    this.element.addEventListener("cocoon:after-insert", this.recalc)
    this.element.addEventListener("cocoon:after-remove", this.recalc)
    this.recalc()
  }

  disconnect() {
    this.element.removeEventListener("cocoon:after-insert", this.recalc)
    this.element.removeEventListener("cocoon:after-remove", this.recalc)
  }

  rateFor(payableGid) {
    if (!payableGid) return 0
    const objectId = this.hasObjectTarget ? this.objectTarget.value : ""
    const byObject = this.ratesValue[objectId] || {}
    const defaults = this.ratesValue._defaults || {}
    const rate = byObject[payableGid] ?? defaults[payableGid] ?? 0
    return Number(rate) || 0
  }

  recalc() {
    let total = 0
    this.rowElements().forEach((row) => {
      const payableGid = row.querySelector("[data-timesheet-target='payable']")?.value
      const hours = Number(row.querySelector("[data-timesheet-target='hours']")?.value) || 0
      const amount = this.rateFor(payableGid) * hours
      const preview = row.querySelector("[data-timesheet-target='amount']")
      if (preview) preview.textContent = this.format(amount)
      total += amount
    })
    if (this.hasTotalTarget) this.totalTarget.textContent = this.format(total)
  }

  rowElements() {
    // Видимые строки (исключаем помеченные на удаление).
    return Array.from(this.rowsTarget.querySelectorAll("[data-row]")).filter((row) => {
      const destroy = row.querySelector("input[name*='_destroy']")
      return !(destroy && destroy.value === "1")
    })
  }

  format(value) {
    return new Intl.NumberFormat("ru-RU", { style: "currency", currency: "RUB" }).format(value)
  }
}
